module.exports = __webpack_public_path__ + "static/img/team_photo.b930732.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team_photo.jpg
// module id = 8Evn
// module chunks = 1